import PropTypes from "prop-types";
import { Button, Dropdown } from "@/config/antd";
import { MoreOutlined } from "@/config/antd";

const MoreOptions = ({ menu, buttonClassName = "" }) => {
  if (!menu) return null;

  return (
    <Dropdown menu={menu} trigger={["click"]} placement="bottomRight">
      <Button
        icon={<MoreOutlined />}
        className={`
          flex items-center justify-center w-8 h-8 min-w-[32px] 
          border border-primary text-primary hover:bg-gray-50 
          sm:w-10 sm:h-10
          ${buttonClassName}
        `}
      />
    </Dropdown>
  );
};

MoreOptions.propTypes = {
  menu: PropTypes.shape({
    items: PropTypes.arrayOf(
      PropTypes.shape({
        key: PropTypes.string,
        label: PropTypes.node,
        icon: PropTypes.node,
        onClick: PropTypes.func,
        disabled: PropTypes.bool,
      })
    ),
  }),
  buttonClassName: PropTypes.string,
};

export default MoreOptions;
